import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37a1476e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copy_icon" }, null, -1))
const _hoisted_3 = { class: "check_icon" }
const _hoisted_4 = { class: "check_hint" }

import { PropType, ref } from 'vue';
import { GameResultEnum, GameItem } from '@/services/types';
import { useBase } from '@/store';
import useClipboard from 'vue-clipboard3';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecordItem',
  props: {
  game: { type: Object as PropType<GameItem>, required: true },
},
  setup(__props) {

const props = __props;



let resetTimer: ReturnType<typeof setTimeout>;
const copyToDisable = ref(false);
const { toClipboard } = useClipboard();
const { handleError } = useBase();

const clickToCopy = async () => {
  try {
    await toClipboard(props.game.gameId);
  } catch (e) {
    handleError({ error: 'ERROR__COPY_FAILED' });
  }

  copyToDisable.value = true;
  // debounce
  clearTimeout(resetTimer);
  resetTimer = setTimeout(() => {
    copyToDisable.value = false;
  }, 2000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(["record_item", {
      defeat: __props.game.gameResult === _unref(GameResultEnum).DEFEAT,
      victory: __props.game.gameResult === _unref(GameResultEnum).VICTORY,
    }])
  }, [
    _createElementVNode("li", null, [
      _createElementVNode("img", {
        src: __props.game.champion,
        alt: ""
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("li", null, [
      _createElementVNode("p", null, _toDisplayString(__props.game.type), 1)
    ]),
    _createElementVNode("li", null, [
      _createElementVNode("p", null, _toDisplayString(__props.game.kda), 1)
    ]),
    _createElementVNode("li", null, [
      _createElementVNode("p", null, _toDisplayString(__props.game.startTime), 1)
    ]),
    _createElementVNode("li", {
      class: _normalizeClass({ disable: copyToDisable.value }),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (clickToCopy()))
    }, [
      _createElementVNode("p", null, _toDisplayString(__props.game.gameId), 1),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('RESULT__HINT__COPY_SUCCESS')), 1)
      ])
    ], 2)
  ], 2))
}
}

})